import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  root: {
    fontSize: 16,
    textTransform: "capitalize",
    letterSpacing: 0.4,
    paddingTop: 4,
    paddingBottom: 4,
    fontWeight: "normal",
  },
  timeline: {
    fontSize: 14,
    textTransform: "capitalize",
    letterSpacing: 0.4,
  },
  timelineWeekend: {
    fontSize: 14,
    textTransform: "capitalize",
  },
}));

export default useStyles;
